import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { Header, Footer, Body } from '@calendly/ui/components/popup'
import { useSelector } from 'react-redux'

import { humanizeTier } from 'features/billing/helpers'
import { currentTierSelector } from 'features/billing/selectors'

import { Paragraph } from '../styles'

export const Success = ({ onClose }) => {
  const currentTier = useSelector(currentTierSelector)

  return (
    <>
      <Header
        title={I18n.t('publisher.billing.scheduled_downgrade.non_renewing_modal.success_title', { tier: humanizeTier(currentTier) })}
      />
      <Body>
        <Paragraph>
          {I18n.t('publisher.billing.scheduled_downgrade.non_renewing_modal.success_text')}
        </Paragraph>
      </Body>
      <Footer>
        <Button
          decoration="secondary-outline"
          onClick={onClose}
        >
          {I18n.t('publisher.action.close')}
        </Button>
      </Footer>
    </>
  )
}
